<template>
  <mescroll-vue class="mescroll white" :class="{'mescroll1': !type&&!isIos}" ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit" id="listId">
    <div ref="wrap">
      <div class="goItem white">
        <van-grid :column-num="5" :border="false" v-if="type">
          <van-grid-item
            v-for="(item, i) in yTabs"
            :key="i"
            :icon="item.icon"
            :text="item.name"
            @click="pushTo(item)"
          >
            <img slot="icon" :src="item.icon" alt="" style="width: 80%">
            <div slot="text" class="f12">{{item.name}}</div>
          </van-grid-item>
        </van-grid>
        <van-grid :column-num="5" :border="false" v-else>
          <van-grid-item
            v-for="(item, i) in tabs"
            :key="i"
            :icon="item.icon"
            :text="item.name"
            @click="pushTo(item)"
          >
            <img slot="icon" :src="item.icon" alt="" style="width: 75%">
            <div slot="text" class="f12">{{item.name}}</div>
          </van-grid-item>
        </van-grid>
      </div>
      <div class="tab" v-if="type!=='1'">
        <div class="flex space_between white f14 pxtab">
          <div @click="changeSort('0')" :class="{'main_co':sortType==='0'}">综合</div>
          <div  @click="changeSort('1')">
            <span :class="{'main_co':sortType==='1'||sortType==='2'}">销量</span>
            <img v-if="sortType==='1'" src="../assets/image/common/paixu_z.png" alt="" style="width: 0.16rem">
            <img v-else-if="sortType==='2'" src="../assets/image/common/paixu_y.png" alt="" style="width: 0.16rem">
            <img v-else src="../assets/image/common/paixu.png" alt="" style="width: 0.16rem">
          </div>
          <div  @click="changeSort('2')">
            <span :class="{'main_co':sortType==='3'||sortType==='4'}">价格</span>
            <img v-if="sortType==='3'" src="../assets/image/common/paixu_z.png" alt="" style="width:0.16rem">
            <img v-else-if="sortType==='4'" src="../assets/image/common/paixu_y.png" alt="" style="width: 0.16rem">
            <img v-else src="../assets/image/common/paixu.png" alt="" style="width: 0.16rem">
          </div>
          <div  @click="changeSort('3')">
            <span :class="{'main_co':sortType==='5'||sortType==='6'}">铜板</span>
            <img v-if="sortType==='5'" src="../assets/image/common/paixu_z.png" alt="" style="width: 0.16rem">
            <img v-else-if="sortType==='6'" src="../assets/image/common/paixu_y.png" alt="" style="width: 0.16rem">
            <img v-else src="../assets/image/common/paixu.png" alt="" style="width: 0.16rem">
          </div>
        </div>
      </div>
      <div>
        <div class="fine flex flex_start white" style="overflow: hidden">
          <div v-if="type==='1'" style="margin: .5rem 0 .3rem;"><img src="../assets/image/detail/cainixihuan.png" alt="" style="width: 60%"></div>
          <div class="fine_item white" v-for="(item, i) in dataList" :key="i">
            <good-card :scale="0.9" :type="type" :item="item" :showType="type==='1'?'1':'ztk'"></good-card>
          </div>
        </div>
      </div>
    </div>
  </mescroll-vue>
</template>

<script>
import { findProductByYjCategory } from '../api/benefit'
import { findAmoyProductListByCategory, findAmoyEjCategory } from '../api/home'
export default {
  name: 'secondHome',
  props: {
    id: String,
    type: String,
    uptab: Object
  },
  data () {
    return {
      yTabs: [],
      tabs: [],
      dataList: [
      ], // 列表数据
      sortType: '0',
      mescrollUp: {
        toTop: {
          // 回到顶部按钮
          // warpId: 'listId',
          warpClass: 'mescroll-totop-my',
          src: require('../assets/image/common/top1.png'), // 图片路径,默认null,支持网络图
          offset: 1000 // 列表滚动1000px才显示回到顶部按钮
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert(22)
      // vm.type ? '' : vm.getSecond()
      // vm.$refs.mescroll && vm.$refs.mescroll.beforeRouteEnter() // 进入路由时,滚动到原来的列表位置,恢复回到顶部按钮和isBounce的配置
    })
  },
  mounted () {
  },

  beforeRouteLeave (to, from, next) {
    next()
  },
  methods: {
    // 切换排序规则
    changeSort (val) {
      switch (val) {
        case '0': this.sortType = '0'
          break
        case '1': this.sortType === '1' ? this.sortType = '2' : this.sortType = '1'
          break
        case '2': this.sortType === '3' ? this.sortType = '4' : this.sortType = '3'
          break
        case '3': this.sortType === '5' ? this.sortType = '6' : this.sortType = '5'
          break
      }
      this.$nextTick(
        function () {
          this.mescroll.resetUpScroll()
        }
      )
    },
    // 下拉刷新
    downCallback () {
      this.mescroll.endSuccess()
    },
    getSecond () {
      // alert(111)
      let data = {
        categoryId: this.uptab.id
      }
      findAmoyEjCategory(data).then(res => {
        if (res.result === '0') {
          this.tabs = res.dataList
        }
      })
    },
    // 上拉加载
    upCallback (val) {
      let data = {
        pageNo: val.num,
        pageSize: val.size,
        categoryId: this.id,
        sortType: this.sortType
      }
      if (val.num === 1) {
        this.dataList = []
      }
      if (this.type === '1') {
        findProductByYjCategory(data).then(res => {
          if (res.result === '0') {
            if (val.num === 1) {
              this.yTabs = res.categoryList
            }
            res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
            this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
          } else {
            this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
          }
        }, err => {
          this.mescroll.endErr()
        })
      } else {
        val.num === 1 ? this.getSecond() : ''
        findAmoyProductListByCategory(data).then(res => {
          if (res.result === '0') {
            res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
            this.mescroll.endByPage(res.dataList.length, res.totalPage)
          }
        }, err => {
          this.mescroll.endErr()
        })
      }
    },
    // 跳转二级分类
    pushTo (item) {
      let temp = new Date().getTime()
      this.$router.push({path: '/List', query: {title: item.name, id: item.id, type: this.type ? 'yd' : 'ztk', 'temp': temp}})
    }
  }
}
</script>

<style scoped>
  .mescroll{
    position: fixed;
    top: 95px;/*no*/
    bottom: 50px;/*no*/
    height: auto; /*如设置bottom:50px,则需height:auto才能生效*/
  }
  .mescroll1{
    position: fixed;
    top: 145px!important;/*no*/
    bottom: 50px;/*no*/
    height: auto; /*如设置bottom:50px,则需height:auto才能生效*/
  }
  .tab{
    margin: .2rem 0;
    line-height: .8rem;
  }
  .tab>div{
    padding: 0 5%;
  }
  /*  精选*/
  .fine{
    /*width: 95%;*/
    margin: 0 auto;
    flex-wrap: wrap;
    padding: 0 4%;
  }
  .fine_item{
    width: 50%;
    margin: 1% 0;
    border-radius: 5px;
  }
  .fine_item>div{
    /*width: 100%;*/
  }
</style>



// WEBPACK FOOTER //
// src/view/secondHome.vue